import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPowTourSttsManagements({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQuerystring({
				powLnCd: searchParams.powLnCd,
				strDt: searchParams.strDt,
				endDt: searchParams.endDt,
				powBttmInfmNo: searchParams.powBttmInfmNo,
				lastYn: searchParams.lastYn,
				pgsStCd: searchParams.pgsStCd,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/ptin/powTourStts/v1/powTourSttss${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getOne({ powBttmInfmNo }) {
		try {
			const response = await client.get(`${BASE_URL}/pqy/ptin/powTourStts/v1/powBttmInfmNo/${powBttmInfmNo}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getSearchOne({ powLnCd, insnDd, ipnNos }) {
		try {
			const response = await client.get(`${BASE_URL}/pqy/ptin/powTourStts/v1/powLnCd/${powLnCd}/insnDd/${insnDd}/ipnNos/${ipnNos}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData(param) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/ptin/powTourStts/v1/status/1`, param, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateData(data) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/ptin/powTourStts/v1/status/2/powBttmInfmNo/${data.powBttmInfmNo}`, data);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deleteData(data) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/ptin/powTourStts/v1/status/3/powBttmInfmNo/${data.powBttmInfmNo}`, data);
			return response.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
